import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Portal } from 'react-portal';
var css = {
  "overlay": "rui-CWqnA",
  "animate": "rui-8uOiP",
  "visible": "rui-9yHXH",
  "overlayContentOpen": "rui-Ui9Nz"
};
import classNames from 'classnames';
var Overlay = /*#__PURE__*/function (_Component) {
  function Overlay(props) {
    var _this;
    _classCallCheck(this, Overlay);
    _this = _callSuper(this, Overlay, [props]);
    _this.componentDidUpdate = function (prevProps) {
      var prevIsOpened = prevProps.isOpened;
      var isOpened = _this.props.isOpened;
      if (prevIsOpened !== isOpened) {
        _this.setState({
          isOpened: isOpened
        });
        if (isOpened) {
          _this.onOpen();
        } else {
          _this.onClose();
        }
      }
    };
    _this.onOpen = function () {
      var _a, _b;
      if (document) {
        document.body.classList.add(css.overlayContentOpen);
      }
      (_b = (_a = _this.props).onOpen) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    _this.onClose = function () {
      var _a, _b;
      if (document) {
        document.body.classList.remove(css.overlayContentOpen);
      } else {
        (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    };
    _this.handleMouseClickOutside = function (e) {
      var _a, _b;
      if (_this.props.closeOnOutsideClick && e.target === _this.content) {
        e.stopPropagation();
        _this.setState({
          isOpened: false
        });
        (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    };
    _this.portal = null;
    _this.content = null;
    _this.state = {
      isOpened: _this.props.isOpened
    };
    return _this;
  }
  _inherits(Overlay, _Component);
  return _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpened === true) {
        this.onOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isOpened = this.state.isOpened;
      var isAnimated = this.props.isAnimated;
      if (isOpened || isAnimated) {
        return /*#__PURE__*/React.createElement(Portal, {
          ref: function ref(c) {
            _this2.portal = c;
          }
        }, /*#__PURE__*/React.createElement("div", {
          onClick: this.handleMouseClickOutside,
          ref: function ref(content) {
            return _this2.content = content;
          },
          className: classNames(css.overlay, _defineProperty(_defineProperty({}, css.animate, isAnimated), css.visible, isOpened && isAnimated), this.props.overlayClassName)
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames(css.content, this.props.contentClassName)
        }, this.props.children)));
      }
      return null;
    }
  }]);
}(Component);
Overlay.defaultProps = {
  isOpened: false,
  closeOnOutsideClick: true,
  overlayClassName: '',
  contentClassName: '',
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  isAnimated: false
};
export default Overlay;